import React from "react";
import styled from 'styled-components'
// reactstrap components
import {
  Container,
  Row,
  Col,
  Card, CardImg, CardBody, CardText
} from "reactstrap";
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import DemoFooter from "components/Footers/DemoFooter.js";
import LogisticsBackground from 'assets/img/logistics123.png';
import truck from 'assets/img/Truck-Card.jpg';
import plane from 'assets/img/Plane-Card.jpg';
import train from 'assets/img/Train-Card.jpeg';
import ship from 'assets/img/Ship-Card.jpg';
import { useTranslation } from 'react-i18next';

const MainText = styled.h3`
    text-align: center;
`

const BackImage = styled.img`
  height: 600px;
  width: 100%;
`


function ProfilePage() {
  const { t, i18n } = useTranslation();
  return (
    <>
      <IndexNavbar />
      <BackImage src={LogisticsBackground} alt='logistics'/>
      <Container>
      <Row>
          <Col md={4}></Col>
          <Col md={4}>
            <MainText>{t('Services')}</MainText>
          </Col>
          <Col md={4}></Col>
       
      </Row>
      <br />
      <Row>
          <Col md={4}>
          <Card style={{width: '20rem'}}>
                <CardImg top src={ship} alt="truck" />
                <CardBody>
                    <CardText>
                    {t('ServicesShip')}
                    </CardText>
                </CardBody>
            </Card>
          </Col>
        <Col md={4}>
            <Card style={{width: '20rem'}}>
                <CardImg top src={plane} alt="truck" />
                <CardBody>
                    <CardText>
                    {t('ServicesPlane')}
                    </CardText>
                </CardBody>
            </Card>
        </Col>
        <Col md={4}>
            <Card style={{width: '20rem'}}>
                <CardImg top src={train} alt="truck" />
                <CardBody>
                    <CardText>
                    {t('ServicesTrain')}
                    </CardText>
                </CardBody>
            </Card>
        </Col>
        
        <Col md={4}></Col>
        <Col md={4}>
        <Card style={{width: '20rem'}}>
                <CardImg top src={truck} alt="truck" />
                <CardBody>
                    <h5>{t('ServicesTruckTitle')}</h5>
                    <CardText>{t('ServicesTruck')}</CardText>
                </CardBody>
            </Card> 
        </Col>
        <Col md={4}></Col>
      </Row>
      <DemoFooter />
      </Container>
    </>
  );
}

export default ProfilePage;
